let path = require('path');

export function getParentPath(inputPath) {
  return path.resolve(inputPath, '..');
}

export function resolveToRelativePath(src, target) {
  if (!target || !src) return src;
  return path.relative(src, target);
}
